import Vue from 'vue';
import { DictionaryService } from '../services/dictionary.service';
import { deptList } from "@/api/api.js"
Vue.filter('DictionaryFilter', function(val, type) {
    let returnVal = val || '';
    if (DictionaryService.dictionary[type]) {
        DictionaryService.dictionary[type].map((item) => {
            if (item['value'] == val) returnVal = item['label'];
        });
    }
    return returnVal;
})
Vue.filter('AssignFilter', function(val, type) {
    let returnVal = val || '';
    deptList().then((res) => {
        console.log(res, '................')
        res.content.forEach(element => {
            if (element['id'] == val) {
                returnVal = element['deptName'],
                    console.log(element['id'], '0000000000')
                console.log(element['deptName'], 'valvalvalval')
            };
        });
    })
    console.log(returnVal, '000')
    return returnVal;

})
Vue.filter('ThousandthFilter', function(number, decimals = 0, decPoint = '.', thousandsSep = ',') {
    number = (number + "").replace(/[^0-9+-Ee.]/g, "")
    let n = !isFinite(+number) ? 0 : +number
    let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    let sep = (typeof thousandsSep === "undefined") ? "," : thousandsSep
    let dec = (typeof decPoint === "undefined") ? "." : decPoint
    let s = ""
    let toFixedFix = function(n, prec) {
        let k = Math.pow(10, prec)
        return "" + Math.ceil(n * k) / k
    }
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".")
    let re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2")
    }
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || ""
        s[1] += new Array(prec - s[1].length + 1).join("0")
    }
    return s.join(dec)
})